import { FC } from "react";
import { Section } from "@/components/Html/Section";
import { Title } from "@/components/home/Title/Title";
import { Item } from "./Item/Item";

interface Props {
  title: string;
  items: { no: string; text: string }[];
}

export const Values: FC<Props> = ({ items, title }) => {
  return (
    <Section className="kdot-container bg-[#FEF1EF] !py-[48px]">
      <Title className="text-[32px] md:text-[2.5rem]" title={title} />
      <Section className="flex flex-wrap gap-[32px]">
        {items.map((item) => (
          <Item key={item.no} no={item.no} text={item.text} />
        ))}
      </Section>
    </Section>
  );
};
